import React from "react";
import { Link } from "react-router-dom";
import BreadcrumbsBg from "../Assets/img/privacy-policy.png";
import axios from "axios";
import Token from "../Config/Token";
const AccountDelete = () => {
  const { user, token, clearUser } = Token();
  const deleteAccount = async () => {
    axios
      .get(`${process.env.React_APP_API_URL}/send/account/delete/request`, {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        const success = res?.data?.success;
        const message = res?.data?.message;
        if (success) {
          clearUser();
          window.location.reload();
        }
      })
      .catch((err) => {
        const errorMessage = err?.response?.data?.message;
        // toast.error(errorMessage);
      });
  };
  return (
    <>
      <section
        className="sodainagar-breadcrumbs"
        style={{ backgroundImage: `url(${BreadcrumbsBg})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
              <div className="sodainagar-breadcrumbs-content">
                <h3 className="sodainagar-bread-cont-title">
                  Account Delete Request{" "}
                </h3>
                <ul className="sodainagar-bread-menu">
                  <li>
                    <Link to="/">Home</Link>
                    <i className="fi fi-br-angle-right"></i>
                  </li>
                  <li className="active">
                    <Link to="/account/delete">Delete Request</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="privacy_policy_body container ">
        <div className="privacy_policy_text">
          <h3>Permanent Delete Account Request</h3>
          <ui>
            <li>1. User Order Information will be kept for future Analysis</li>
            <li>2. User behavioural data will be deleted (if kept)</li>
            <li>
              3. User Account will be deleted within 90 days after submitting
              delete request
            </li>
            <li>
              4. Deletion Process will be cancelled if user login again in
              between the delete time range (90 days)
            </li>
          </ui>
          <div className="d-flex justify-content-end">
            <button className="theme-btn" onClick={deleteAccount}>
              Submit Request
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountDelete;
